import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { StickNav } from 'views/rebranded-module/common/components';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.primary,
  '& .LVCustomContainer': {
    '@media (max-width:1420px)': {
      padding: theme.spacing(0, 8),
    },
    [theme.breakpoints.down('xl')]: {
      padding: theme.spacing(0, 10),
    },
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(0, 3),
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 2),
    },
  },
  '& .TSBGPattern': {
    position: 'absolute',
    top: 0,
    zIndex: 1,
    width: '100%',
    height: theme.typography.pxToRem(200),
    opacity: 0.2,
    '&:after': {
      content: '""',
      background: 'linear-gradient(180deg, #000 50%, rgba(0, 0, 0, 1) 100%)',
      width: '100%',
      height: '100%',
      zIndex: 1,
      position: 'absolute',
      left: 0,
      top: 0,
      opacity: 0.75,
    },
  },
  '& .LVRentalsSection': {
    padding: theme.spacing(16, 0),
    backgroundColor: theme.palette.background.secondary,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(8, 0),
    },
  },
  '& .LVSectionSpacing': {
    padding: theme.spacing(16, 0),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(8, 0),
    },
  },
  '& .LVEventRideSection': {
    borderTop: `1px solid ${theme.palette.divider[7]}`,
  },
}));

export const StyledStickNav = styled(StickNav)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  [theme.breakpoints.up('lg')]: {
    padding: 0,
    '& .MuiTabs-flexContainer': {
      justifyContent: 'center',
    },
  },
}));

export default StyledBox;
